import React, { useRef, useEffect, useState } from "react";
import classes from "./andLeaderBoard.module.css";
import {
  AMIT_SHAH,
  AND_ARENA_TXT,
  ARTIST_1,
  ARTIST_2,
  ARTIST_3,
  ARTIST_4,
  ARTIST_5,
  CROWN,
  MODI,
  SANSKAR,
  TROPHY,
} from "../../utils/images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLeaderboards } from "../../redux/slices/andArenaSlice";

const PremiumEmptyLeaderboardSVG = () => (
  <svg
    viewBox="0 0 800 550"
    xmlns="http://www.w3.org/2000/svg"
    className={classes.emptyStateSvg}
  >
    {/* Background with premium gradient */}
    <defs>
      <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1a1a1a" />
        <stop offset="100%" stopColor="#111111" />
      </linearGradient>

      {/* Red glow for trophy and accents */}
      <filter id="redGlow" x="-30%" y="-30%" width="160%" height="160%">
        <feGaussianBlur stdDeviation="8" result="blur" />
        <feFlood floodColor="#e61919" floodOpacity="0.7" result="glowColor" />
        <feComposite
          in="glowColor"
          in2="blur"
          operator="in"
          result="softGlow"
        />
        <feComposite in="SourceGraphic" in2="softGlow" operator="over" />
      </filter>

      {/* Trophy metallic gradient */}
      <linearGradient id="trophyGradient" x1="0%" y1="0%" x2="80%" y2="80%">
        <stop offset="0%" stopColor="#e6c200" />
        <stop offset="50%" stopColor="#ffd700" />
        <stop offset="100%" stopColor="#c29a00" />
      </linearGradient>

      {/* Podium texture */}
      <linearGradient id="podiumGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2d2d2d" />
        <stop offset="100%" stopColor="#222222" />
      </linearGradient>

      {/* Red accent for podium top */}
      <linearGradient id="redAccent" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#cc0000" />
        <stop offset="100%" stopColor="#ff1a1a" />
      </linearGradient>
    </defs>

    {/* Background rectangle */}
    <rect width="800" height="500" fill="url(#bgGradient)" rx="8" ry="8" />

    {/* Abstract design elements */}
    <path
      d="M0,250 Q200,350 400,250 T800,250 V500 H0 Z"
      fill="#1c1c1c"
      opacity="0.5"
    />
    <path
      d="M800,150 Q600,50 400,150 T0,150 V0 H800 Z"
      fill="#1c1c1c"
      opacity="0.5"
    />

    {/* Subtle grid pattern */}
    <g opacity="0.1">
      <line x1="0" y1="100" x2="800" y2="100" stroke="#fff" strokeWidth="1" />
      <line x1="0" y1="200" x2="800" y2="200" stroke="#fff" strokeWidth="1" />
      <line x1="0" y1="300" x2="800" y2="300" stroke="#fff" strokeWidth="1" />
      <line x1="0" y1="400" x2="800" y2="400" stroke="#fff" strokeWidth="1" />
      <line x1="200" y1="0" x2="200" y2="500" stroke="#fff" strokeWidth="1" />
      <line x1="400" y1="0" x2="400" y2="500" stroke="#fff" strokeWidth="1" />
      <line x1="600" y1="0" x2="600" y2="500" stroke="#fff" strokeWidth="1" />
    </g>

    {/* Red accent lines */}
    <line
      x1="0"
      y1="40"
      x2="800"
      y2="40"
      stroke="#cc0000"
      strokeWidth="3"
      opacity="0.8"
    />
    <line
      x1="0"
      y1="460"
      x2="800"
      y2="460"
      stroke="#cc0000"
      strokeWidth="3"
      opacity="0.8"
    />

    {/* Premium podium design */}
    <g transform="translate(400, 330)">
      {/* Second place podium */}
      <g transform="translate(-180, -100)">
        <rect
          x="0"
          y="20"
          width="120"
          height="80"
          fill="url(#podiumGradient)"
          rx="2"
          ry="2"
        />
        <rect x="0" y="16" width="120" height="4" fill="url(#redAccent)" />
        <text
          x="60"
          y="65"
          fontFamily="Arial, sans-serif"
          fontSize="18"
          fontWeight="bold"
          fill="#aaa"
          textAnchor="middle"
        >
          2
        </text>
      </g>

      {/* First place podium */}
      <g transform="translate(-60, -140)">
        <rect
          x="0"
          y="20"
          width="120"
          height="120"
          fill="url(#podiumGradient)"
          rx="2"
          ry="2"
        />
        <rect x="0" y="16" width="120" height="4" fill="url(#redAccent)" />
        <text
          x="60"
          y="85"
          fontFamily="Arial, sans-serif"
          fontSize="22"
          fontWeight="bold"
          fill="#aaa"
          textAnchor="middle"
        >
          1
        </text>
      </g>

      {/* Third place podium */}
      <g transform="translate(60, -80)">
        <rect
          x="0"
          y="20"
          width="120"
          height="60"
          fill="url(#podiumGradient)"
          rx="2"
          ry="2"
        />
        <rect x="0" y="16" width="120" height="4" fill="url(#redAccent)" />
        <text
          x="60"
          y="55"
          fontFamily="Arial, sans-serif"
          fontSize="18"
          fontWeight="bold"
          fill="#aaa"
          textAnchor="middle"
        >
          3
        </text>
      </g>
    </g>

    {/* Premium trophy */}
    <g transform="translate(400, 130)">
      {/* Trophy cup */}
      <path
        d="M-40,-40 L40,-40 L45,-35 C60,-30 70,-10 70,20 C70,50 40,60 0,70 C-40,60 -70,50 -70,20 C-70,-10 -60,-30 -45,-35 L-40,-40 Z"
        fill="url(#trophyGradient)"
        stroke="#c29a00"
        strokeWidth="2"
        filter="url(#redGlow)"
      />

      {/* Trophy handles */}
      <path
        d="M-40,-40 C-60,-40 -80,-30 -90,-10 C-100,10 -90,30 -70,40 C-60,45 -50,45 -40,40"
        fill="none"
        stroke="#c29a00"
        strokeWidth="2"
      />
      <path
        d="M40,-40 C60,-40 80,-30 90,-10 C100,10 90,30 70,40 C60,45 50,45 40,40"
        fill="none"
        stroke="#c29a00"
        strokeWidth="2"
      />

      {/* Trophy base */}
      <rect x="-30" y="70" width="60" height="8" fill="#c29a00" />
      <rect x="-40" y="78" width="80" height="12" fill="#c29a00" />

      {/* Trophy highlights */}
      <path
        d="M-30,-30 Q-10,-35 10,-30 T40,-32"
        fill="none"
        stroke="#fff"
        strokeWidth="1"
        opacity="0.6"
      />
      <ellipse cx="-15" cy="-15" rx="8" ry="12" fill="#fff" opacity="0.3" />

      {/* Trophy engraving detail */}
      <path d="M-20,20 H20" stroke="#c29a00" strokeWidth="1.5" />
      <path d="M-15,30 H15" stroke="#c29a00" strokeWidth="1.5" />
      <path d="M-10,40 H10" stroke="#c29a00" strokeWidth="1.5" />
    </g>

    {/* Red accent circle behind trophy */}
    <circle
      cx="400"
      cy="140"
      r="100"
      fill="none"
      stroke="#cc0000"
      strokeWidth="4"
      strokeDasharray="10,15"
      opacity="0.3"
    />

    {/* Premium text styling for empty state */}
    <g>
      <text
        x="400"
        y="280"
        fontFamily="'Arial', sans-serif"
        fontSize="28"
        fontWeight="bold"
        fill="#fff"
        textAnchor="middle"
      >
        LEADERBOARD COMING SOON
      </text>
      <rect x="260" y="290" width="280" height="2" fill="#e61919" />
      <text
        x="400"
        y="320"
        fontFamily="'Arial', sans-serif"
        fontSize="16"
        fill="#aaa"
        textAnchor="middle"
      >
        Be the first to compete and see your name here
      </text>
    </g>

    {/* Action button */}
    <g transform="translate(400, 370)" filter="url(#redGlow)" opacity="0.9">
      <rect
        x="-100"
        y="-20"
        width="200"
        height="40"
        rx="4"
        ry="4"
        fill="#cc0000"
      />
      <text
        x="0"
        y="6"
        fontFamily="'Arial', sans-serif"
        fontSize="16"
        fontWeight="bold"
        fill="#fff"
        textAnchor="middle"
      >
        CHECK AGAIN
      </text>
    </g>

    {/* Small accent dots */}
    <circle cx="150" cy="60" r="3" fill="#e61919" />
    <circle cx="650" cy="60" r="3" fill="#e61919" />
    <circle cx="150" cy="440" r="3" fill="#e61919" />
    <circle cx="650" cy="440" r="3" fill="#e61919" />
  </svg>
);

const ANDLeaderBoard = () => {
  const sliderRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const { leaderboards } = useSelector((state) => state.andArena);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await dispatch(fetchAllLeaderboards());
      setIsLoading(false);
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Dynamic settings based on screen size
  const getSlidesToShow = () => {
    if (windowWidth <= 576) return 1;
    if (windowWidth <= 768) return 1;
    if (windowWidth <= 992) return 3;
    return 3;
  };

  const getCenterPadding = () => {
    if (windowWidth <= 576) return "20px";
    if (windowWidth <= 768) return "40px";
    if (windowWidth <= 992) return "40px";
    return "0px";
  };

  // Slick settings for centered mode with responsive adjustments
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: getCenterPadding(),
    slidesToShow: getSlidesToShow(),
    speed: 500,
    focusOnSelect: true,
    dots: true,
    arrows: true,
    autoplay: windowWidth <= 768 ? false : true, // Disable autoplay on mobile for better UX
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          centerPadding: "20px",
          arrows: windowWidth <= 400 ? false : true, // Hide arrows on very small screens
        },
      },
    ],
  };

  // Function to format numbers (e.g., 51000 -> 51K)
  const formatVotes = (votes) => {
    if (votes >= 1000) {
      return `${(votes / 1000).toFixed(1)}K`;
    }
    return votes;
  };

  // Truncate names for smaller screens
  const truncateName = (name, maxLength = 12) => {
    if (windowWidth <= 576 && name.length > maxLength) {
      return `${name.substring(0, maxLength)}...`;
    }
    return name;
  };

  // Handle refresh when clicking the refresh button in the empty state
  const handleRefresh = () => {
    setIsLoading(true);
    dispatch(fetchAllLeaderboards()).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <div className={classes.outerMostContainer}>
      <div className={classes.topMostContainer}>
        <div className={classes.carouselHeader}>
          <img
            src={AND_ARENA_TXT}
            alt="AND Arena"
            className={classes.logoImage}
          />
          <p className={classes.mainTagline}>
            Meet the <span className={classes.highlightText}>stars</span> in the
            making!
          </p>
        </div>
        {windowWidth > 576 && (
          <div className={classes.trophyContainer}>
            <img src={TROPHY} className={classes.trophyImg} alt="Trophy" />
          </div>
        )}
      </div>

      {windowWidth <= 576 && (
        <div className={classes.trophyContainer}>
          <img src={TROPHY} className={classes.trophyImg} alt="Trophy" />
        </div>
      )}

      <div className={classes.leaderBoardContainer}>
        {isLoading ? (
          <div className={classes.loadingContainer}>
            <div className={classes.spinner}></div>
            <p>Loading leaderboards...</p>
          </div>
        ) : (
          <div className={classes.sliderContainer}>
            {leaderboards?.length > 0 ? (
              <Slider ref={sliderRef} {...settings}>
                {leaderboards?.map((category, index) => (
                  <div key={index} className={classes.sliderItem}>
                    <div className={classes.leaderBoardCard}>
                      <p className={classes.title}>{category.title}</p>
                      <div className={classes.topThree}>
                        <div className={classes.secondPositionContainer}>
                          <div className={classes.topRank}>
                            <img
                              src={category.second.profileImg}
                              alt={category.second.name}
                            />
                          </div>
                          <p className={classes.topArtistNameTxt}>
                            {truncateName(category.second.name)}
                          </p>
                          <p className={classes.topArtistVoteTxt}>
                            {formatVotes(category.second.votes)} votes
                          </p>
                        </div>
                        <div className={classes.firstPositionContainer}>
                          <div className={classes.topRankFirst}>
                            <img
                              src={CROWN}
                              className={classes.crownImg}
                              alt="Crown"
                            />
                            <img
                              src={category.first.profileImg}
                              alt={category.first.name}
                            />
                          </div>
                          <p className={classes.topArtistNameTxt}>
                            {truncateName(category.first.name)}
                          </p>
                          <p className={classes.topArtistVoteTxt}>
                            {formatVotes(category.first.votes)} votes
                          </p>
                        </div>

                        <div className={classes.thirdPositionContainer}>
                          <div className={classes.topRank}>
                            <img
                              src={category.third.profileImg}
                              alt={category.third.name}
                            />
                          </div>
                          <p className={classes.topArtistNameTxt}>
                            {truncateName(category.third.name)}
                          </p>
                          <p className={classes.topArtistVoteTxt}>
                            {formatVotes(category.third.votes)} votes
                          </p>
                        </div>
                      </div>
                      <div className={classes.rankingList}>
                        {category.rankings.map((person, i) => (
                          <div
                            key={i}
                            className={`${classes.rankingItem} ${
                              person.highlight ? classes.highlight : ""
                            }`}
                          >
                            <div className={classes.personName}>
                              <p className={classes.artistSerialAndTxt}>
                                {i + 4}
                              </p>
                              <img
                                src={person.profileImg}
                                className={classes.artistShortImg}
                                alt={person.name}
                              />

                              <p className={classes.artistSerialAndTxt}>
                                {truncateName(person.name, 10)}
                              </p>
                            </div>
                            <div className={classes.voteCount}>
                              {formatVotes(person.votes)} votes
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className={classes.buttons}>
                        <button className={classes.voteBtn}>
                          {windowWidth <= 400 ? "Vote" : "🗳 Vote Now"}
                        </button>
                        <button className={classes.performBtn}>
                          {windowWidth <= 400 ? "View" : "Performances"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div
                className={classes.emptyStateContainer}
                onClick={handleRefresh}
              >
                <PremiumEmptyLeaderboardSVG />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ANDLeaderBoard;
